<template>
    <div class="payment-card-item">
        <div class="payment-card-item__title">
            Achiziție
        </div>
        <div class="payment-card-item__row">
            <div class="payment-card-item__details">
                Serie
            </div>
            <div class="payment-card-item__value skeleton" v-if="skeleton" style="min-height: 20px; max-width: 100px; width: 100%;"></div>
            <div class="payment-card-item__value" v-else>
                {{this.invoiceSeries}}
            </div>
        </div>
        <div class="payment-card-item__row">
            <div class="payment-card-item__details">
                Data
            </div>
            <div class="payment-card-item__value skeleton" v-if="skeleton" style="min-height: 20px; max-width: 100px; width: 100%;"></div>
            <div class="payment-card-item__value" v-else>
                {{momentDate}}
            </div>
        </div>
        <div class="payment-card-item__row">
            <div class="payment-card-item__details">
                Suma
            </div>
            <div class="payment-card-item__value skeleton" v-if="skeleton" style="min-height: 20px; max-width: 30px; width: 100%;"></div>
            <div class="payment-card-item__value" v-else>
                <span v-if="this.vat">*</span>
                {{this.totalPrice}}
            </div>
        </div>
        <div class="payment-card-item__row">
            <div class="payment-card-item__details">
                Moneda
            </div>
            <div class="payment-card-item__value skeleton" v-if="skeleton" style="min-height: 20px; max-width: 30px; width: 100%;"></div>
            <div class="payment-card-item__value" v-else>
                {{currency}}
            </div>
        </div>
        <div class="payment-card-item__row">
            <div class="payment-card-item__details">
                Descriere
            </div>
            <div class="payment-card-item__value skeleton" v-if="skeleton" style="min-height: 20px; max-width: 80px; width: 100%;"></div>
            <div class="payment-card-item__value" v-else>
                {{this.description}}
            </div>
        </div>
        <div class="payment-card-item__button skeleton" v-if="skeleton" style="min-height: 35px; max-width: 100%; width: 100%; border-radius: 18px; margin-top: 7px;"></div>
        <Button name="Descarcă factura" class="payment-card-item__button" @click="showInvoice" v-else/>
    </div>
</template>

<script>
    import Button from '@/components/ui/Button'
    import * as moment from 'moment'
    import config from '@/config'

    export default {
        components: {
            Button
        },
        props: {
            date: {
                type: String,
                default: ''
            },
            price: {
                type: Number,
                default: 0
            },
            vat: {
                type: Number,
                default: 0
            },
            currency: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            invoice: {
                type: Object,
                default: () => { return {}; }
            },
            skeleton: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            momentDate() {
                let dateString = this.date.slice(0, 4)+this.date.slice(5, 7)+this.date.slice(8, 10);
                return moment(dateString).format('L');
            },
            paymentURL(){
                let invoiceDate = moment(this.invoice.created_at).format('YYYY-MM');
                return config.HOST + '/storage/invoices/' + invoiceDate + '/' + this.invoice.secret + '.pdf'; 
            },
            invoiceSeries(){
                Number.prototype.pad = function(size) {
                    var sign = Math.sign(this) === -1 ? '-' : '';
                    return sign + new Array(size).concat([Math.abs(this)]).join('0').slice(-size);
                }

                return this.invoice.series + this.invoice.number.pad(6);
            },
            description(){
                console.log(this.type);
                switch(this.type){
                    case 'TOPUP':
                        return 'Alimentare cont';
                        break;
                    case 'SERVICE':
                        return 'Achiziție sedinta';
                        break;
                    case 'PACKAGE':
                        return 'Achiziție pachet';
                        break;
                    case 'APPOINTMENT':
                        return 'Finalizare programare';
                        break;
                }

                return 'Plata efectuata';
            },
            totalPrice() {
                return ((this.price + this.vat)/100).toFixed(2);
            }
        },
        methods: {
            showInvoice: function(){
                window.open(this.paymentURL,'_blank');
            }
        }
    }
</script>
<style lang="scss" scoped>
    .payment-card-item {
        width: 100%;
        max-width: 340px;
        box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
        padding-bottom: 15px;
        background: white;
        padding: 15px;
        display: flex;
        flex-direction: column;
        transition: box-shadow 0.3s;

        &:hover{
            box-shadow: 0px 0px 20px 0px rgba($color-secondary, 80%);
        }

        &__title {
            font-size: 20px;
            font-weight: 500;
            line-height: 25px;
            text-align: center;
            position: relative;
            width: 100%;
            margin-bottom: 20px;

            &::after {
                content: "";
                position: absolute;
                bottom: -5px;
                left: 0;
                width: 100%;
                height: 1px;
                background-image: $gradient-nexyo;
            }
        }

        &__row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            line-height: 20px;
            opacity: .7;
            margin-bottom: 8px;

            &:last-of-type{
                margin-bottom: 15px;
            }
        }

        &__details {
            font-family: 'Roboto';
            font-weight: 400;
            text-align: left;
        }

        &__value {
            font-family: 'Roboto';
            font-weight: 500;
            text-align: right;
        }

        &__button {
            width: 100%;
            margin: auto auto 0px auto;
        }
    }
</style>